const LAST_ACTIVITY_KEY = "session_last_activity_ms";
export const DEFAULT_TIMEOUT_MINUTES = 20;

let timeoutMinutes = DEFAULT_TIMEOUT_MINUTES;
let configLoaded = false;
let configPromise = null;

export function getTimeoutMinutes() {
  return timeoutMinutes;
}

export async function loadSessionTimeoutConfig(apiUrl) {
  if (configLoaded) return timeoutMinutes;
  if (!configPromise) {
    configPromise = fetch(`${apiUrl}/limits`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const minutes = data?.session_inactivity_timeout_minutes;
        if (Number.isFinite(minutes) && minutes > 0) {
          timeoutMinutes = minutes;
        }
      })
      .catch(() => {})
      .finally(() => {
        configLoaded = true;
      });
  }
  await configPromise;
  return timeoutMinutes;
}

export function recordActivity() {
  localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
}

export function clearLastActivity() {
  localStorage.removeItem(LAST_ACTIVITY_KEY);
}

export function bootstrapActivityIfMissing() {
  if (!localStorage.getItem(LAST_ACTIVITY_KEY)) {
    recordActivity();
  }
}

export function isSessionExpired() {
  const lastRaw = localStorage.getItem(LAST_ACTIVITY_KEY);
  if (!lastRaw) return false;

  const lastMs = parseInt(lastRaw, 10);
  if (!Number.isFinite(lastMs)) return false;

  const elapsedMs = Date.now() - lastMs;
  return elapsedMs > getTimeoutMinutes() * 60 * 1000;
}
